import {isApiTrue}        from "@Common/logic/is-api-true";
import {BlockGuestAccess} from "@Common/logic/block-guest-access";
import {cs}               from "@Common/react/chain-services";
import {consumeContext}   from "@Common/react/context";
import {cascadeFind}      from "@Common/utils/cascade";

import {ApplyCreditLine} from "../common/apply-credit-line";

import {setVouchers} from "./set-vouchers";

export const VoucherSection = ({store, next}) => cs(
    consumeContext("company"),
    consumeContext("apis"),
    ["blockGuestAccess", (_, next) => BlockGuestAccess({next})],
    ({company, apis, blockGuestAccess}) => next({
        available: cascadeFind(store.cart.items, `[*].billingAvailable.voucher[0]`) && isApiTrue(company?.prefs?.enableVouchers) && !blockGuestAccess,
        render: () => (
            ApplyCreditLine({
                label: "Voucher",
                cartAttr: "vouchers",
                itemAttr: "voucher",
                applyChange: (value) => store.dispatch(setVouchers(value, {apis})),
                store,
            })
        )
    }),
);
